import { Component, OnInit } from '@angular/core';

import { ParametroService } from './../../_services/parametro.service';
import { MessageService } from './../../_services/message.service';

@Component({
  selector: 'app-parametro',
  templateUrl: './parametro.component.html',
  styleUrls: ['./parametro.component.scss']
})
export class ParametroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
